import React from 'react';

const SatisfactionGuarantee = () => {
  return (
    <section id="satisfaction-guarantee" className="py-20 bg-gradient-to-br from-primary/10 via-white to-accent/5 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_30%_40%,rgba(255,87,34,0.08)_0%,rgba(255,255,255,0)_60%)]"></div>
      
      <div className="container relative z-10">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Risk-Free <span className="text-primary">Investment Protection</span>
          </h2>
          <p className="text-xl text-secondary-light">
            We've already done the work - you just need to approve it.
          </p>
        </div>
        
        <div className="glass-card p-8 md:p-12 max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <div className="w-full md:w-1/3 flex justify-center">
              <div className="w-40 h-40 flex items-center justify-center rounded-full bg-primary/10 p-4">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-20 h-20 text-primary">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
            </div>
            
            <div className="w-full md:w-2/3 text-left">
              <h3 className="text-2xl font-semibold mb-4">Low-Risk Investment Process</h3>
              <ul className="space-y-4">
                <li className="flex gap-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6 text-primary flex-shrink-0 mt-0.5">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <p className="text-lg">
                    <span className="font-medium">$500 to start</span> - Shows we're both committed to success
                  </p>
                </li>
                <li className="flex gap-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6 text-primary flex-shrink-0 mt-0.5">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <p className="text-lg">
                    <span className="font-medium">$1,000 due only when website is delivered</span> - No surprises or hidden fees
                  </p>
                </li>
                <li className="flex gap-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6 text-primary flex-shrink-0 mt-0.5">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <p className="text-lg">
                    <span className="font-medium">100% money-back guarantee</span> - If you're not completely satisfied, we return your $500
                  </p>
                </li>
                <li className="flex gap-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6 text-primary flex-shrink-0 mt-0.5">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <p className="text-lg">
                    <span className="font-medium">No contracts or ongoing obligations</span> - Simple, straightforward process
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SatisfactionGuarantee;
